<script lang="ts" setup>
	import { type ClassNameValue } from 'tailwind-merge'

	defineProps<{ className?: ClassNameValue }>()
	defineOptions({
		inheritAttrs: false
	})
</script>
<template>
	<section :class="cn('max-w-[1440px] mx-auto px-[19px] md:px-14', className)">
		<slot />
	</section>
</template>

<style></style>
